import React, { ReactElement } from 'react'
import { AWS_S3_URL } from 'utils/constants'
import { Center, Image, Text } from '@conekta/frontino-ui/v2'
import { useTranslation } from 'react-i18next'
import './Auth.scss'

const IMG_MAIN_LOGO_SYMBOL = `${AWS_S3_URL}/img/conekta-logo-symbol.svg`

const Loader = (): ReactElement => {
  const { t } = useTranslation()
  const loadingText = t('loading')

  return (
    <section className='Auth row center-xs center-sm center-md center-lg'>
      <Center className='Auth__message col-xs-6 col-sm-6 col-md-6 col-lg-6' flexDirection='column'>
        <Image src={IMG_MAIN_LOGO_SYMBOL} alt='conekta logo cargando' />
        <Text>{loadingText}</Text>
      </Center>
    </section>
  )
}

export default Loader
